import { StyledSummaryBarCellBorderElement } from "./Detail.styles";

/**
 * SummaryBarCellBorder
 *
 * Renders an empty, styled cell element used as a visual border within a
 * summary bar layout.
 *
 */

const SummaryBarCellBorder = () => {
  return <StyledSummaryBarCellBorderElement></StyledSummaryBarCellBorderElement>;
};

export { SummaryBarCellBorder };
